export const DATA_CONFIG: { nullString: string } = {
    nullString: '--',
}
